<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowUpThick } from "@mdi/js";
export default {
  name: "MdiArrowUpThick",
  data() {
    return {
      svgPath: mdiArrowUpThick,
    };
  },
};
</script>
